export enum CalendarView {
  WEEK = 'week',
  MONTH = 'month',
}

export enum TransitionDirection {
  FORWARD = 'forward',
  BACK = 'back',
}

export const CUBIC_BEZIER = 'cubic-bezier(.17,.67,.83,.67)';
